import { all } from 'redux-saga/effects';
import { watchSearchRequest } from './search';
import { watchPageMount, watchSearchResultClick } from './analytics';
import { watchPageNav, watchPageNavErrors } from './page';
import { watchArticleFeedback, watchArticleFeedbackForm, } from './articleFeedback';
// notice how we now only export the rootSaga
// single entry point to start all Sagas at once
export default function* rootSaga() {
    yield all([
        watchPageMount(),
        watchSearchRequest(),
        watchSearchResultClick(),
        watchPageNav(),
        watchPageNavErrors(),
        watchArticleFeedback(),
        watchArticleFeedbackForm(),
    ]);
}
//# sourceMappingURL=index.js.map